import { eqBy,prop, unionWith } from "ramda";

export const defaultScopeId = "v3.comments";

export const SUBSCRIBE = "COMMENTS/SUBSCRIBE";
export const UNSUBSCRIBE = "COMMENTS/UNSUBSCRIBE";
export const UPDATE_MANY = "COMMENTS/UPDATE_MANY";
export const LOAD_SUCCEEDED = "COMMENTS/LOAD_SUCCEEDED";
export const LOAD_FAILED = "COMMENTS/LOAD_FAILED";
export const LOAD_REQUESTED = "COMMENTS/LOAD_REQUESTED";
export const CREATE_REQUESTED = "COMMENTS/CREATE_REQUESTED";
export const UPDATE_REQUESTED = "COMMENTS/UPDATE_REQUESTED";
export const UPSERT_REQUESTED = "COMMENTS/UPSERT_REQUESTED";
export const CREATE_SUCCEEDED = "COMMENTS/CREATE_SUCCEEDED";
export const UPDATE_SUCCEEDED = "COMMENTS/UPDATE_SUCCEEDED";
export const UPSERT_SUCCEEDED = "COMMENTS/UPSERT_SUCCEEDED";
export const CREATE_FAILED = "COMMENTS/CREATE_FAILED";
export const UPDATE_FAILED = "COMMENTS/UPDATE_FAILED";
export const UPSERT_FAILED = "COMMENTS/UPSERT_FAILED";
export const UPDATE_CONTENT_REQUESTED = "COMMENTS/UPDATE_CONTENT_REQUESTED";
export const DELETE_REQUESTED = "COMMENTS/DELETE_REQUESTED";
export const ARCHIVE_REQUESTED = "COMMENTS/ARCHIVE_REQUESTED";
export const REPLY_REQUESTED = "COMMENTS/REPLY_REQUESTED";
export const UPDATE_CONTENT_SUCCEEDED = "COMMENTS/UPDATE_CONTENT_SUCCEEDED";
export const DELETE_SUCCEEDED = "COMMENTS/DELETE_SUCCEEDED";
export const ARCHIVE_SUCCEEDED = "COMMENTS/ARCHIVE_SUCCEEDED";
export const REPLY_SUCCEEDED = "COMMENTS/REPLY_SUCCEEDED";
export const UPDATE_CONTENT_FAILED = "COMMENTS/UPDATE_CONTENT_FAILED";
export const DELETE_FAILED = "COMMENTS/DELETE_FAILED";
export const ARCHIVE_FAILED = "COMMENTS/ARCHIVE_FAILED";
export const REPLY_FAILED = "COMMENTS/REPLY_FAILED";

const findById = commentId => ({ id }) =>  commentId === id;
const mergeCommentsById = unionWith(eqBy(prop("id")));

// eslint-disable-next-line complexity, max-statements
export default (state = {
    archiving: 0,
    comments: [],
    creating: 0, 
    deleting: 0, 
    errors: [], 
    loading: 0, 
    subscriptions: 0,
    updating: 0, 
    /* comments: [{ id: id1, content: 'foo', .... }, .....] */ 
}, { type, data }) => {
    switch (type) {
    case SUBSCRIBE: {
        ++state.subscriptions;
        return state;
    }
    case UNSUBSCRIBE: {
        --state.subscriptions;
        return state;
    }
    case UPDATE_MANY: {
        console.log(data.comments);
        state.comments = mergeCommentsById(data.comments, state.comments);
        return state;
    }
    case LOAD_REQUESTED: {
        ++state.loading;
        const { commentId } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.loading = true;
        }
        return state;
    }
    case LOAD_FAILED: {
        --state.loading;
        const { commentId, error } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.loading = false;
            comment.error = error;
        }
        state.errors.push({ error, commentId, type });
        return state;
    }
    case LOAD_SUCCEEDED: {
        --state.loading;
        const { commentId, ...properties } = data;
        Object.assign(state.comments.find(findById(commentId)) || {}, properties, {
            loading: false
        });
        return state;
    }
    case UPSERT_SUCCEEDED:
    case UPDATE_SUCCEEDED:  {
        const { commentId , ...properties } = data;
        Object.assign(state.comments.find(findById(commentId)) || {}, properties, {
            updating: false
        });
        --state.updating;
        return state;
    }
    case ARCHIVE_SUCCEEDED: {
        const { commentId , archived } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.archived = archived;
            comment.archiving = false;
        }
        --state.archiving;
        return state;
    }
    case UPDATE_CONTENT_SUCCEEDED: {
        const { commentId , content } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.content = content;
            comment.updating = false;
        }
        --state.updating;
        return state;
    }
    case REPLY_SUCCEEDED:
    case CREATE_SUCCEEDED: {
        state.comments.push(data);
        --state.creating;
        return state;
    }
    case DELETE_SUCCEEDED: {
        const { commentId } = data;
        state.comments.splice(state.comments.findIndex(findById(commentId)), 1);
        --state.deleting;
        return state;
    }

    case UPSERT_REQUESTED:
    case UPDATE_CONTENT_REQUESTED:
    case UPDATE_REQUESTED:  {
        const { commentId } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.updating = true;
        }
        ++state.updating;
        return state;
    }
    case ARCHIVE_REQUESTED: {
        const { commentId } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.archiving = true;
        }
        ++state.archiving;
        return state;
    }
    case REPLY_REQUESTED:
    case CREATE_REQUESTED:  {
        ++state.creating;
        return state;
    }
    case DELETE_REQUESTED: {
        const { commentId } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.deleting = true;
        }
        ++state.deleting;
        return state;
    }

    case UPSERT_FAILED:
    case UPDATE_CONTENT_FAILED:
    case UPDATE_FAILED:  {
        const { commentId, error } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.updating = false;
            comment.error = error;
        }
        state.errors.push({ error, commentId, type });
        state.lastError = error;
        --state.updating;
        return state;
    }
    case ARCHIVE_FAILED: {
        const { commentId, error } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.archiving = false;
            comment.error = error;
        }
        state.errors.push({ error, commentId, type });
        state.lastError = error;
        --state.archiving;
        return state;
    }
    case REPLY_FAILED:
    case CREATE_FAILED:  {
        const { commentId, error } = data;
        state.errors.push({ error, commentId, type });
        state.lastError = error;
        --state.creating;
        return state;
    }
    case DELETE_FAILED: {
        const { commentId, error } = data;
        const comment = state.comments.find(findById(commentId));
        if (comment){
            comment.deleting = false;
            comment.error = error;
        }
        state.errors.push({ error, commentId, type });
        state.lastError = error;
        --state.deleting;
        return state;
    }
    
    default: return state;
    }
};

export const subscribeToComment = ({ commentId, chunkId }) => ({ type: SUBSCRIBE, data: { commentId, chunkId } });
export const unsubscribeFromComments = ({ commentId, chunkId }) => ({ type: UNSUBSCRIBE, data: { commentId, chunkId } });
export const successLoadComment = data => ({ type: LOAD_SUCCEEDED, data });
export const failLoadComment = data => ({ type: LOAD_FAILED, data });
export const requestLoadComment = ({ chunkId }) => ({ type: LOAD_REQUESTED, data: { chunkId } });
export const updateManyComments = data => ({ type: UPDATE_MANY, data });

export const requestCommentCreate = (data, resolve, reject) => ({ type: CREATE_REQUESTED, data, resolve, reject });
export const requestCommentUpdate = (data, resolve, reject) => ({ type: UPDATE_REQUESTED, data, resolve, reject });
export const requestCommentUpsert = (data, resolve, reject) => ({ type: UPSERT_REQUESTED, data, resolve, reject });
export const succeedCommentCreate = data => ({ type: CREATE_SUCCEEDED, data });
export const succeedCommentUpdate = data => ({ type: UPDATE_SUCCEEDED, data });
export const succeedCommentUpsert = data => ({ type: UPSERT_SUCCEEDED, data });
export const failCommentCreate = data => ({ type: CREATE_FAILED, data });
export const failCommentUpdate = data => ({ type: UPDATE_FAILED, data });
export const failCommentUpsert = data => ({ type: UPSERT_FAILED, data });
export const requestCommentUpdatecontent = (data, resolve, reject) => ({ type: UPDATE_CONTENT_REQUESTED, data, resolve, reject });
export const requestCommentDelete = (data, resolve, reject) => ({ type: DELETE_REQUESTED, data, resolve, reject });
export const requestCommentArchive = (data, resolve, reject) => ({ type: ARCHIVE_REQUESTED, data, resolve, reject });
export const requestCommentReply = (data, resolve, reject) => ({ type: REPLY_REQUESTED, data, resolve, reject });
export const succeedCommentUpdatecontent = data => ({ type: UPDATE_CONTENT_SUCCEEDED, data });
export const succeedCommentDelete = data => ({ type: DELETE_SUCCEEDED, data });
export const succeedCommentArchive = data => ({ type: ARCHIVE_SUCCEEDED, data });
export const succeedCommentReply = data => ({ type: REPLY_SUCCEEDED, data });
export const failCommentUpdatecontent = data => ({ type: UPDATE_CONTENT_FAILED, data });
export const failCommentDelete = data => ({ type: DELETE_FAILED, data });
export const failCommentArchive = data => ({ type: ARCHIVE_FAILED, data });
export const failCommentReply = data => ({ type: REPLY_FAILED, data });
